import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Post, PostPayload } from "../interfaces";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "./http.service";

@Injectable({ providedIn: "root" })
export class PostService {
  private post$: BehaviorSubject<Post>;
  private post: Post = <Post>{};

  constructor(private http: HttpClient, private httpService: HttpService) {
    this.post$ = new BehaviorSubject(this.post);
  }

  getPost$(): Observable<Post> {
    return this.post$.asObservable();
  }

  getPost(): Post {
    return this.post;
  }

  setPost$(post: Post): void {
    this.post$.next(post);
  }

  setPost(post: Post): void {
    this.post = post;
  }

  createPost(postPayload: PostPayload): Observable<Post> {
    return this.http.post<Post>(
      `${environment.apiBaseUrl}/post}`,
      postPayload,
    );
  }

  getPostById(postId: string): Observable<Post> {
    return this.http.get<Post>(
      `${environment.apiBaseUrl}/post/${postId}`,
    );
  }

  updatePost(
    postId: string,
    partialPost: Partial<Post>,
  ): Observable<Post> {
    return this.http.patch<Post>(
      `${environment.apiBaseUrl}/post/${postId}`,
      partialPost,
    );
  }

  deletePost(postId: string): Observable<Post> {
    return this.http.delete<Post>(
      `${environment.apiBaseUrl}/post/${postId}`,
    );
  }

  getPostsByAccountId(accountId: string): Observable<Post[]> {
    return this.http.get<Post[]>(
      `${environment.apiBaseUrl}/posts/${accountId}`,
      this.httpService.getOptions()
    );
  }
}
